import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Textarea } from 'components';
import styles from './RejectModal.module.scss';

const RejectModal = ({
    show,
    onHide,
    onSubmit,
    submitLabel,
    textAreaValue,
    onChangeTextArea,
    title,
    placeholder,
    children,
}: RejectModalsProps) => {
    const submit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (onSubmit) {
            await onSubmit();
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            dialogClassName={styles.rejectModal}
        >
            <Modal.Header
                closeButton
                className={styles.rejectModal__header}
            >
                <span className={styles.title}>{title}</span>
            </Modal.Header>
            <Form onSubmit={submit}>
                <Modal.Body className={styles.rejectModal__body}>
                    {children}
                    <Form.Group controlId="exampleForm.ControlTextarea1">
                        <Textarea
                            name='textarea'
                            placeholder={placeholder || 'Опишите причину отклонения'}
                            value={textAreaValue}
                            onChange={(value) => onChangeTextArea(value)}
                            rows={7}
                            required
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className={styles.rejectModal__footer}>
                    <Button type="submit">{submitLabel || 'Отклонить'}</Button>
                    <Button onClick={onHide} variant="outline-secondary">Отмена</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default RejectModal;

interface RejectModalsProps {
    textAreaValue: string;
    title: string;
    show: boolean;
    submitLabel?: string;
    placeholder?: string;
    children?: React.ReactNode;
    onHide: () => void;
    onChangeTextArea: (value: string) => void;
    onSubmit?: () => void;
}
